var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MOK",
    transform: "translate(-924.321 -316.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69506",
    "data-name": "Group 69506",
    transform: "translate(928.683 319.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44835",
    "data-name": "Path 44835",
    d: "M963.7,359.823c.012.083-.056.174-.2.225a3.84,3.84,0,0,0-1.393.829c-.175.168-.3.07-.442-.042q-2.522-1.94-5.048-3.874-6.326-4.848-12.658-9.69a.491.491,0,0,1-.2-.658,3.876,3.876,0,0,0,.108-2.119.385.385,0,0,1,.222-.488q6.965-4.107,13.924-8.229a.35.35,0,0,1,.5.034,3.95,3.95,0,0,0,2.131,1.059.369.369,0,0,1,.348.379q.62,5.191,1.252,10.381.559,4.644,1.109,9.287c.108.893.224,1.785.335,2.678C963.689,359.647,963.693,359.7,963.7,359.823Z",
    transform: "translate(-924.85 -314.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44836",
    "data-name": "Path 44836",
    d: "M938.919,322.364c-.056-.172.043-.289.27-.356a3.446,3.446,0,0,0,1.369-.807c.177-.165.3-.146.489-.007q4.642,3.483,9.293,6.951,3.956,2.956,7.913,5.911c.159.117.232.213.148.426a4.079,4.079,0,0,0-.183,2.323.412.412,0,0,1-.232.513q-3.157,1.852-6.3,3.716l-7.392,4.37a2.087,2.087,0,0,0-.207.125.375.375,0,0,1-.569-.044,3.869,3.869,0,0,0-1.939-.986.319.319,0,0,1-.289-.329q-.332-3.14-.672-6.281c-.23-2.114-.468-4.228-.7-6.34-.212-1.941-.415-3.884-.626-5.824C939.172,324.625,939.049,323.528,938.919,322.364Z",
    transform: "translate(-925.799 -318.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44837",
    "data-name": "Path 44837",
    d: "M951.242,361.475q-4.993,0-9.985,0c-.28,0-.417-.067-.452-.376a3.27,3.27,0,0,0-1.626-2.548.476.476,0,0,1-.262-.59q1.015-5.206,2-10.42a.394.394,0,0,1,.389-.372,3.776,3.776,0,0,0,1.9-.78c.211-.165.349-.045.5.073q2.089,1.606,4.181,3.211Q954.7,354.9,961.513,360.1c.238.182.332.35.213.636-.093.223.008.546-.184.688s-.486.049-.735.05q-4.783,0-9.565,0Z",
    transform: "translate(-925.8 -312.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44838",
    "data-name": "Path 44838",
    d: "M970.993,338.686a4.342,4.342,0,0,0,.9,3.329,3.489,3.489,0,0,0,.983.893c.217.131.235.25.114.464q-1.446,2.587-2.877,5.181-2.848,5.145-5.694,10.29c-.237.428-.484.85-.71,1.283-.1.2-.22.24-.408.133a.824.824,0,0,0-.309-.117c-.424-.032-.508-.3-.551-.679-.284-2.447-.588-4.891-.883-7.336-.291-2.416-.575-4.832-.866-7.247q-.375-3.1-.758-6.21c-.065-.527-.121-1.056-.193-1.583a.408.408,0,0,1,.262-.481,3.71,3.71,0,0,0,1.48-1.269.389.389,0,0,1,.552-.159q3.439,1.262,6.883,2.505c.613.224,1.226.449,1.842.667C970.934,338.413,971.046,338.5,970.993,338.686Z",
    transform: "translate(-921.681 -314.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44839",
    "data-name": "Path 44839",
    d: "M941.527,344.292c.02.163-.068.241-.2.3a3.977,3.977,0,0,0-1.775,1.468c-.129.2-.267.155-.44.1q-3.908-1.29-7.816-2.574c-.3-.1-.592-.2-.89-.285a.32.32,0,0,1-.258-.351,4.2,4.2,0,0,0-2.042-3.7c-.218-.138-.144-.263-.048-.427q1.691-2.9,3.375-5.812,3.167-5.455,6.332-10.912c.254-.439.239-.369.7-.281.607.116.676.5.725,1.012.147,1.568.331,3.132.5,4.7s.343,3.131.514,4.7q.26,2.378.519,4.758.253,2.316.5,4.634.138,1.266.276,2.531C941.51,344.192,941.52,344.242,941.527,344.292Z",
    transform: "translate(-927.963 -317.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44840",
    "data-name": "Path 44840",
    d: "M942.578,318.746c2.825-.089,5.7-.01,8.58-.071,2.617-.055,5.233-.024,7.85-.053q.781-.009,1.562-.048c.261-.012.337.09.347.357a4.2,4.2,0,0,0,2.3,3.792.393.393,0,0,1,.231.508q-.778,3.91-1.534,7.826c-.065.332-.129.663-.188.995a.308.308,0,0,1-.327.287,3.861,3.861,0,0,0-1.932.7.368.368,0,0,1-.5,0q-6.534-4.9-13.077-9.784c-1.431-1.07-2.86-2.144-4.3-3.208-.192-.141-.279-.28-.183-.509a.127.127,0,0,0,.007-.029c.072-.234,0-.548.176-.695.21-.174.523-.044.789-.067C942.427,318.743,942.478,318.746,942.578,318.746Z",
    transform: "translate(-925.313 -318.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44841",
    "data-name": "Path 44841",
    d: "M941.14,348.184l-.226,1.174q-.923,4.819-1.843,9.637c-.039.208-.122.336-.333.369a1.627,1.627,0,0,0-.261.071c-.495.158-.5.159-.763-.312q-4.691-8.276-9.387-16.548c-.144-.252-.1-.373.115-.516a2.761,2.761,0,0,0,.855-.9c.168-.285.347-.287.619-.2,1.581.531,3.164,1.05,4.748,1.572,1.26.415,2.518.833,3.78,1.238a.379.379,0,0,1,.316.407,4.088,4.088,0,0,0,2.193,3.749C941.048,347.992,941.16,348.033,941.14,348.184Z",
    transform: "translate(-927.907 -313.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44842",
    "data-name": "Path 44842",
    d: "M963.538,321.924c.156.023.188.158.245.258q1.006,1.763,2.005,3.532,3.519,6.2,7.037,12.406c.206.362.2.366-.122.6a3.9,3.9,0,0,0-.738.674.307.307,0,0,1-.393.1q-4.517-1.646-9.039-3.277a.41.41,0,0,1-.31-.447,4.065,4.065,0,0,0-2.072-3.636.362.362,0,0,1-.182-.453c.562-2.848,1.131-5.695,1.659-8.55.092-.5.243-.76.764-.785a2.339,2.339,0,0,0,.934-.323C963.4,321.985,963.471,321.955,963.538,321.924Z",
    transform: "translate(-921.637 -317.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(924.321 341.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3155",
    "data-name": "Ellipse 3155",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(938.325 316.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3156",
    "data-name": "Ellipse 3156",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(966.161 316.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3157",
    "data-name": "Ellipse 3157",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(979.834 341.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3158",
    "data-name": "Ellipse 3158",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(941.314 347.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3159",
    "data-name": "Ellipse 3159",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(962.909 334.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3160",
    "data-name": "Ellipse 3160",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(937.951 365.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3161",
    "data-name": "Ellipse 3161",
    cx: 2.244,
    cy: 2.291,
    rx: 2.244,
    ry: 2.291,
    transform: "translate(966.358 365.993)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMok);
export default __webpack_public_path__ + "static/media/mok.09467a3042c0771667f6b0c25a451224.svg";
export { ForwardRef as ReactComponent };